/**
 * QuickFilters Component
 *
 * Feature: 123-audit-log-viewer
 * Description: Pre-defined quick filter chips with a labeled row
 * Constitution: v1.23.0
 * Task: T026 · Spec 216 T032 — aligned to the System Audit Log's labeled
 * quick-filter row (same kit Buttons + "Quick filters:" label).
 */

import React from 'react';
import { ListFilter } from 'lucide-react';
import { Button } from '../../../components/ui';
import type { QuickFilter } from '../../../types/audit';

interface QuickFiltersProps {
  quickFilters: QuickFilter[];
  activeFilterId: string | null;
  onApply: (filter: QuickFilter) => void;
}

export default function QuickFilters({
  quickFilters,
  activeFilterId,
  onApply,
}: QuickFiltersProps) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <span className="flex items-center gap-1 text-sm font-medium text-[var(--color-text-secondary)]">
        <ListFilter className="h-4 w-4" /> Quick filters:
      </span>
      {quickFilters.map((filter) => {
        const isActive = activeFilterId === filter.id;
        return (
          <Button
            key={filter.id}
            size="sm"
            variant={isActive ? 'primary' : 'outline'}
            onClick={() => onApply(filter)}
          >
            {filter.label}
          </Button>
        );
      })}
    </div>
  );
}
